export const FALLBACK_ACTIVE_OWNER_THRESHOLD = 0; // number of days since an owner's last action to consider the owner active
export const FALLBACK_RECENT_LISTING_THRESHOLD = 7; // number of days since a listing was published to consider the listing recently published
